export const NO_ACCESS_PATH = 'ikketilgang?returnUrl='
